const axios = require("axios");
const md5 = require("md5");
const qs = require("qs");
const { default: DBUtils } = require("../utils/dbUtils");
const header = {
  "Content-Type": "application/x-www-form-urlencoded"
};

exports.verifyToken = ({ state, commit }, payload) => {
  return new Promise((resolve, reject) => {
    let url = "/api/uc/eft/verify/token",
      params = {
        token: state.token
      },
      success = res => {
        let { code, message, data = {} } = res.data;
        if (code == 200) {
          commit("updateUsrInfo", data.vo);
          commit("saveDB");
          resolve(code);
        } else {
          commit("clearInfo");
          commit("saveDB");
          reject({ code, message });
        }
      },
      fail = err => {
        reject({ code: err.status, message: err.statusText });
      };
    axios
      .post(url, qs.stringify(params), { headers: header })
      .then(success, fail);
  });
};

exports.loginByEftToken = ({ state, commit, rootState }, payload) => {
  return new Promise((resolve, reject) => {
    let url = "/api/uc/eft/login/token",
      params = {
        token: payload.urlToken
      },
      success = res => {
        let { code, message, data = {} } = res.data;
        if (code == 200) {
          commit("updateUsrInfo", data.vo);
          commit("saveDB");
          resolve(code);
        } else {
          commit("clearInfo");
          commit("saveDB");
          reject({ code, message });
        }
      },
      fail = err => {
        reject({ code: err.status, message: err.statusText });
      };
    axios
      .post(url, qs.stringify(params), { headers: header })
      .then(success, fail);
  });
};

exports.logout = ({ state, commit, rootState }, payload) => {
  return new Promise((resolve, reject) => {
    let url = "/api/uc/user/logout?token=" + state.token,
      success = res => {
        commit("clearInfo");
        commit("saveDB");
        resolve({ code: 200 });
      },
      fail = err => {
        reject({ code: err.status, message: err.statusText });
      };
    axios.get(url).then(success, fail);
  });
};

exports.initDB = ({ state, commit, rootState }, payload) => {
  return new Promise((resolve, reject) => {
    commit("updateDBLoadingState", true);
    DBUtils.initDB(() => {
      commit("updateDBLoadingState", false);
      resolve();
    });
  });
};
exports.signUp = ({ state, commit, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      let url = "/api-uc/usr/add/global",
        params = {
          nickname: payload.nickname,
          email: payload.email,
          pw: md5(payload.pw),
          origin: payload.origin, 
          orgName: payload.orgName,
          spread: payload.spread,
        },
        success = res => {
          let { code, message, data = {} } = res.data;
          if (code == 200) {
            console.log(data)
            commit("updateUsrInfo", data);
            commit("saveDB");
            resolve(code);
          } else {
            commit("clearInfo");
            commit("saveDB");
            reject({ code, message });
          }
        },
        fail = err => {
          reject({ code: err.status, message: err.statusText });
        };
      axios
        .post(url, qs.stringify(params), { headers: header })
        .then(success, fail);
    });
  };
  exports.signIn = ({ state, commit, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      let url = "/api-uc/auth/login/email",
        params = {
          email: payload.email,
          pw: md5(payload.pw),
        },
        success = res => {
          let { code, message, data = {} } = res.data;
          if (code == 200) {
            commit("updateUsrInfo", data);
            commit("saveDB");
            resolve(code);
          } else {
            commit("clearInfo");
            commit("saveDB");
            reject({ code, message });
          }
        },
        fail = err => {
          reject({ code: err.status, message: err.statusText });
        };
      axios
        .post(url, qs.stringify(params), { headers: header })
        .then(success, fail);
    });
  };
